import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSchedulecalender = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "selectAppointment",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16872",
		"data-name": "Group 16872",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12491",
				"data-name": "Path 12491",
				d: "M16,2V6",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12492",
				"data-name": "Path 12492",
				d: "M8,2V6",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12493",
				"data-name": "Path 12493",
				d: "M3,9H21",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12494",
				"data-name": "Path 12494",
				d: "M19,4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Z",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12495",
				"data-name": "Path 12495",
				d: "M9,9V21",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12496",
				"data-name": "Path 12496",
				d: "M15,9V21",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12497",
				"data-name": "Path 12497",
				d: "M3,15H21",
				fill: "none",
				stroke: "#304393",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12498",
		"data-name": "Path 12498",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgSchedulecalender;
